import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Auth/Login.vue";
import Logout from "../views/Auth/Logout.vue";
import ChangePass from "../views/Auth/ChangePass.vue";
import LoginAdmin from "../views/Auth/LoginAdmin.vue";

import { authenticationService } from "@/_services";
import { Role } from "@/plugins/roles";

import jsonData from '../../public/domainConfig.json';
import i18n from "./i18n";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/register",
      name: "register",
      component: () => import("../views/Register/Register.vue")
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout
    },
    {
      path: "/change-pass",
      name: "changePass",
      component: ChangePass
    },
    {
      path: "/admin/login",
      name: "login-admin",
      component: LoginAdmin
    },

    {
      path: "/h/:hotelIdParam",
      name: "about",
      redirect: "/h/:hotelIdParam/dashboard/widgets",
      meta: {
        roles: []
      },
      component: () => import("@/views/Main.vue"),
      children: [
        // DASHBOARD
        {
          path: "dashboard",
          name: "dashboard",
          redirect: "/dashboard/widgets",
          meta: { roles: [Role.DASHBOARD] },
          component: () => import("@/views/About.vue"),
          children: [
            // DASHBOARD
            {
              path: "widgets",
              name: "widgets",
              meta: {
                roles: [Role.DASHBOARD]
              },
              component: () => import("@/components/Dashboard/Widgets.vue")
            }
          ]
        },
        // GROUP
        {
          path: "group",
          name: "group",
          meta: {
            roles: ['HOTEL_BOOKING_GROUP']
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "info",
              redirect: "info/list-booking",
              name: "group-info",
              meta: {
                roles: ['HOTEL_BOOKING_GROUP']
              },
              component: () =>
                import("../components/Group/GroupComponent.vue"),
              children: [
                {
                  path: "profiles",
                  name: "profilesGroup",
                  meta: {
                    roles: ['HOTEL_BOOKING_GROUP']
                  },
                  component: () => import("@/components/Group/ListProfileGroup.vue")
                },
                {
                  path: "profiles/detail/:code",
                  name: "detailProfilesGroup",
                  meta: {
                    roles: ['HOTEL_BOOKING_GROUP']
                  },
                  component: () => import("@/components/Group/DetailProfileGroup.vue")
                },

                {
                  path: "list-booking",
                  name: "listBookingGroup",
                  meta: {
                    roles: ['HOTEL_BOOKING_GROUP']
                  },
                  component: () => import("@/components/Group/ListBooking.vue"),
                },
                {
                  path: "list-booking/detail/:code",
                  name: "bookingDetailGroup",
                  meta: {
                    roles: ['HOTEL_BOOKING_GROUP']
                  },
                  component: () => import("@/components/Group/BookingDetail.vue")
                }
              ]
            },

          ]
        },
        //  chain

        {
          path: "chain",
          name: "chain",
          redirect: "/chain/chain-infomation",
          meta: {
            roles: [
              Role.CHAIN
            ]
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "chain-booking-list",
              name: "chain-booking-list",
              component: () => import("@/components/Chain/ListBookingGroup.vue"),
              meta: {
                roles: ['BOOKING_CHAIN']
              }
            },
            {
              path: "bookingDetail/:code",
              name: "groupBookingDetail",
              component: () => import("@/components/Chain/BookingDetailGroup.vue"),
              meta: {
                roles: ['BOOKING_CHAIN']
              }
            },
            {
              path: "chain-infomation",
              name: "chain-infomation",
              component: () => import("@/components/Chain/ChainInfo.vue"),
              meta: {
                roles: [
                  Role.CHAIN,
                  // Role.CHAIN_LIST
                ]
              }
            },
            {
              path: "room",
              name: "chain-room",
              redirect: "room/room-type",
              component: () => import("@/components/Chain/Room/RoomComponent.vue"),
              meta: {
                roles: ['CHAIN_ROOM_TYPE']
              },
              children: [
                {
                  path: "room-type",
                  name: "chain-room-type",
                  component: () => import("@/components/Chain/RoomTypeList.vue"),
                  meta: {
                    roles: ['CHAIN_ROOM_TYPE']
                  }
                },
                {
                  path: "room-category",
                  name: "chain-roomCategorys",
                  component: () => import("@/components/Chain/RoomCategory/RoomCategoryList.vue"),
                  meta: {
                    roles: ['CHAIN_ROOM_TYPE']
                  }
                },
              ]
            },
            {
              path: "chain-category/detail/:id",
              name: "chain-roomCategoryDetail",
              meta: {
                roles: ['CHAIN_ROOM_TYPE']
              },
              component: () =>
                import("@/components/Chain/RoomCategory/RoomCategoryDetail.vue")
            },

            {
              path: "room-type/roomInfo/:id",
              name: "room-infomation",
              redirect: "room-type/roomInfo/:id/infor",
              meta: {
                roles: ['CHAIN_ROOM_TYPE']
              },
              component: () => import("@/components/Chain/RoomTypeInfomation.vue"),
              children: [
                {
                  path: "infor",
                  name: "chainRoomInformation",
                  meta: {
                    roles: ['CHAIN_ROOM_TYPE']
                  },
                  component: () =>
                    import("@/components/Chain/Room/RoomInfomation.vue")
                },
                {
                  path: "amenities",
                  name: "chainRoomAmenities",
                  meta: {
                    roles: ['CHAIN_ROOM_TYPE']
                  },
                  component: () =>
                    import("@/components/Chain/Room/RoomExtension.vue")
                },
                {
                  path: "images",
                  name: "chainRoomImages",
                  meta: {
                    roles: ['CHAIN_ROOM_TYPE']
                  },
                  component: () =>
                    import("@/components/Chain/Room/RoomImage.vue")
                }
              ]
            },
            // pms rate
            {
              path: "rate-pms",
              name: "ratePms",
              component: () => import("@/components/Chain/Pms/RatePmsOverView.vue"),
              meta: {
                roles: ['CHAIN_ROOM_TYPE']
              }
            },
            {
              path: "rate-pms-update",
              name: "ratePmsUpdate",
              component: () => import("@/components/Chain/Pms/RatePmsUpdate.vue"),
              meta: {
                roles: ['CHAIN_ROOM_TYPE']
              }
            },
            // giá
            {
              path: "rate/",
              name: "chainRate",
              meta: {
                roles: ['CHAIN_RATE_PLAN']
              },
              redirect: "rate/rate-plan",
              component: () =>
                import("@/components/Chain/Rate.vue"),
              children: [
                // Màn danh sách gói bán phòng
                {
                  path: "rate-plan",
                  name: "chain-rate-plan",
                  meta: {
                    roles: ['CHAIN_RATE_PLAN']
                  },
                  component: () => import("@/components/Chain/RatePlanList.vue"),
                },
                // Màn chi tiết gói bán phòng
                {
                  path: "rate-plan/info/:id",
                  name: "chain-rate-plan-infomation",
                  meta: {
                    roles: ['CHAIN_RATE_PLAN']
                  },
                  component: () => import("@/components/Chain/RoomPlanInfomation.vue"),
                },
                {
                  path: "rate-category",
                  name: "ChainRateCategorys",
                  meta: {
                    roles: ['CHAIN_RATE_PLAN']
                  },
                  component: () =>
                    import("@/components/Chain/RateCategory/RateCategoryList.vue")
                },
                // Màn chi tiết gói bán phòng
                {
                  path: "rate-category/:id",
                  name: "ChainRateCategoryDetail",
                  meta: {
                    roles: ['CHAIN_RATE_PLAN']
                  },
                  component: () =>
                    import("@/components/Chain/RateCategory/RateCategoryDetail.vue")
                },
                {
                  path: "ota-price-configuration/:id",
                  name: "chain-updateRateByRatePlan",
                  meta: {
                    roles: ['CHAIN_RATE_PLAN']
                  },
                  component: () =>
                    import("@/components/Chain/UpdateRateByRatePlan.vue")
                }
              ]
            },
            {
              path: "service",
              name: "chain-service",
              component: () => import("@/components/Chain/Service/ListOfService.vue"),
              meta: {
                roles: ['CHAIN_SERVICE']
              }
            },
            {
              path: "service/detail/:id",
              name: "chain-service-detail",
              component: () => import("@/components/Chain/Service/ServiceDetail.vue"),
              meta: {
                roles: ['CHAIN_SERVICE']
              }
            },
            {
              path: "agent",
              name: "ChainAgent",
              meta: {
                roles: ['CHAIN_TRAVEL_AGENT']
              },
              component: () =>
                import("../components/Chain/ChainAgentList.vue")
            },
            {
              path: "agent/info/:id",
              name: "ChainAgentInfomation",
              component: () => import("@/components/Chain/ChainAgentInfomation.vue"),
              meta: {
                roles: ['CHAIN_TRAVEL_AGENT']
              }
            },
                // chain log
            {
              path: "chain-log",
              name: "chainLog",
              redirect: "/chain-log/log",
              meta: {
                roles: [Role.HISTORY_LOG]
              },
              component: () => import("@/views/About.vue"),
              children: [
                // GET LOG
                {
                  path: "log",
                  name: "chainLogList",
                  meta: {
                    roles: [Role.HISTORY_LOG]
                  },
                  component: () => import("@/components/Log/ChainLog.vue")
                },
              ]
            },
          ]
        },



        // DANH SÁCH ĐẶT PHÒNG
        {
          path: "booking/",
          name: "listBookings",
          redirect: "/booking/list-booking",
          meta: {
            roles: [Role.MANAGE, Role.BOOKING_HOTEL]
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "list-booking",
              name: "listBooking",
              meta: {
                roles: [Role.MANAGE, Role.BOOKING_HOTEL]
              },
              component: () => import("@/components/Booking/ListBooking.vue")
            },
            {
              path: "detail/:code",
              name: "bookingDetail",
              meta: {
                roles: [Role.MANAGE, Role.BOOKING_HOTEL]
              },
              component: () => import("@/components/Booking/BookingDetail.vue")
            },
            {
              path: "list-booking-unmap",
              name: "listBookingUnmap",
              meta: {
                roles: ['BOOKING_UNMAP_HOTEL']
              },
              component: () => import("@/components/Booking/ListBookingUnmap.vue")
            },
            {
              path: "detail-unmap/:code",
              name: "bookingDetailUnmap",
              meta: {
                roles: ['BOOKING_UNMAP_HOTEL']
              },
              component: () => import("@/components/Booking/BookingDetailUnmap.vue")
            }
          ]
        },
        // BÁN PHÒNG
        {
          path: "room-sale",
          redirect: "/room-sale/room-sale",
          name: "roomSales",
          meta: {
            roles: [Role.MANAGE, Role.ROOM_SALE]
          },
          component: () => import("@/views/About.vue"),
          children: [
            // Màn bán phòng
            {
              path: "room-sale",
              name: "roomSale",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
              },
              redirect: "/room-sale/room-sale/room-sale-otas",
              component: () => import("@/components/RoomSale/RoomSale/RoomSaleMain.vue"),
              children: [
                {
                  path: "room-sale-ota",
                  name: "roomSaleOTA",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                  },
                  component: () => import("@/components/RoomSale/RoomSale/RoomSale.vue"),
                  children: [

                  ]
                },
                {
                  path: "room-sale-otas",
                  name: "roomSaleWithOTAs",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                  },
                  component: () => import("@/components/RoomSale/RoomSale/RoomSaleWithOtas.vue"),
                  children: [

                  ]
                },
                {
                  path: "room-sale-calendar",
                  name: "roomSaleWithCalendar",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                  },
                  component: () => import("@/components/RoomSale/RoomSale/RoomSaleCalendar.vue"),
                  children: [

                  ]
                },
              ]
            },
            {
              path: "room-sale-update",
              name: "roomSaleUpdate",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
              },
              component: () => import("@/components/RoomSale/RoomSale/RoomSaleUpdate.vue"),
              children: [
                {
                  path: "room-avail",
                  name: "roomAvailUpdate",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                  },
                  component: () => import("@/components/RoomSale/RoomSale/RoomAvailUpdate.vue")
                },
                {
                  path: "price",
                  name: "priceUpdate",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                  },
                  component: () => import("@/components/RoomSale/RoomSale/PriceComponent.vue"),

                  redirect: "price/price-base",
                  children: [
                    {
                      path: "price-base",
                      name: "basePriceUpdate",
                      meta: {
                        roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                      },
                      component: () => import("@/components/RoomSale/RoomSale/PriceUpdate.vue")
                    },
                    {
                      path: "special-price",
                      name: "specialPriceUpdate",
                      meta: {
                        roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                      },
                      component: () => import("@/components/RoomSale/RoomSale/SpecialPriceUpdate.vue")
                    },
                    {
                      path: "price-extra",
                      name: "priceExtraUpdate",
                      meta: {
                        roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                      },
                      component: () => import("@/components/RoomSale/RoomSale/PriceExtraUpdate.vue")
                    },
                    {
                      path: "price-extra-special",
                      name: "priceExtraSpecialUpdate",
                      meta: {
                        roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                      },
                      component: () => import("@/components/RoomSale/RoomSale/PriceExtraSpecialUpdate.vue")
                    },
                    {
                      path: "price-room-special",
                      name: "priceRoomSpecialUpdate",
                      meta: {
                        roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                      },
                      component: () => import("@/components/RoomSale/RoomSale/PriceRoomSpecialUpdate.vue")
                    },
                  ]
                },

                {
                  path: "restriction",
                  name: "restrictionUpdate",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                  },
                  component: () => import("@/components/RoomSale/RoomSale/RestrictionUpdate.vue")
                },
                {
                  path: "stop-sell",
                  name: "stopSellUpdate",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                  },
                  component: () => import("@/components/RoomSale/RoomSale/StopSellUpdate.vue"),
                  redirect: "stop-sell/stop-sell-limit",
                  children: [
                    {
                      path: "sell-limit",
                      name: "stopSellLimit",
                      meta: {
                        roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                      },
                      component: () => import("@/components/RoomSale/RoomSale/StopSellLimit.vue"),
                    },
                    {
                      path: "stop-sell-limit",
                      name: "stopUnderSellLimit",
                      meta: {
                        roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
                      },
                      component: () => import("@/components/RoomSale/RoomSale/StopUnderSellLimit.vue"),
                    }
                  ]
                },
              ]
            },
            // Màn danh sách gói hạn chế
            {
              path: "restriction/package",
              name: "listPackageRestriction",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
              },
              component: () =>
                import("@/components/RoomSale/Restriction/ListPackageRestriction.vue")
            },
            // Màn chi tiết gói hạn chế
            {
              path: "restriction/package/:id",
              name: "detailPackageRestriction",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
              },
              component: () =>
                import("@/components/RoomSale/Restriction/DetailPackageRestriction.vue")
            },
            // giá
            {
              path: "rate/",
              name: "rate",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.SALE_PACKAGE_MANAGEMENT]
              },
              redirect: "rate/package",
              component: () =>
                import("@/components/RoomSale/Rate/Rate.vue"),
              children: [
                // Màn danh sách gói bán phòng
                {
                  path: "package",
                  name: "listOfSalePackages",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.SALE_PACKAGE_MANAGEMENT]
                  },
                  component: () =>
                    import("@/components/RoomSale/RoomPlan/ListPackageRoomPlan.vue")
                },
                // Màn chi tiết gói bán phòng
                {
                  path: "package/:id",
                  name: "editSalePackages",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.SALE_PACKAGE_MANAGEMENT]
                  },
                  component: () =>
                    import("@/components/RoomSale/RoomPlan/DetailPackageRoomPlan.vue")
                },
                {
                  path: "rate-category",
                  name: "rateCategorys",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.SALE_PACKAGE_MANAGEMENT]
                  },
                  component: () =>
                    import("@/components/RoomSale/Rate/RateCategory/RateCategoryList.vue")
                },
                // Màn chi tiết gói bán phòng
                {
                  path: "rate-category/:id",
                  name: "rateCategoryDetail",
                  meta: {
                    roles: [Role.MANAGE, Role.ROOM_SALE, Role.SALE_PACKAGE_MANAGEMENT]
                  },
                  component: () =>
                    import("@/components/RoomSale/Rate/RateCategory/RateCategoryDetail.vue")
                }
              ]
            },

          ]
        },
        // RMS
        {
          path: "rms-management",
          redirect: "rms-management/dynamic",
          name: "roomSales",
          meta: {
            roles: ['RMS_MANAGEMENT', 'RMS']
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "dynamic",
              name: "dynammic-component",
              redirect: "dynamic/schedule",
              meta: {
                roles: ['DYNAMIC_ROOM_SALE', 'RMS']
              },
              component: () => import("@/components/RoomSale/Dynamic/DynamicComponent.vue"),
              children: [
                {
                  path: "pricing",
                  name: "dynammic-pricing-list",
                  meta: {
                    roles: ['DYNAMIC_PRICING', 'RMS']
                  },
                  component: () => import("@/components/RoomSale/DynamicPricing/DynamicList.vue")
                },
                {
                  path: "pricing/detail/:id",
                  name: "dynammic-pricing-detail",
                  meta: {
                    roles: ['DYNAMIC_PRICING', 'RMS']
                  },
                  component: () => import("@/components/RoomSale/DynamicPricing/DynamicDetail.vue")
                },
                {
                  path: "schedule",
                  name: "schedule",
                  meta: {
                    roles: ['DYNAMIC_CONFIGURATION', 'RMS']
                  },
                  component: () => import("@/components/RoomSale/Dynamic/ConfigSchedule.vue")
                },
                {
                  path: "restriction",
                  name: "dynammic-restriction-list",
                  meta: {
                    roles: ['DYNAMIC_RESTRICTION', 'RMS']
                  },
                  component: () => import("@/components/RoomSale/DynamicRestriction/DynamicList.vue")
                },
                {
                  path: "restriction/detail/:id",
                  name: "dynammic-restriction-detail",
                  meta: {
                    roles: ['DYNAMIC_RESTRICTION', 'RMS']
                  },
                  component: () => import("@/components/RoomSale/DynamicRestriction/DynamicDetail.vue")
                },
              ]
            },
            {
              path: "overview",
              name: "dynammic-overview",
              meta: {
                roles: ['DYNAMIC_PRICING', 'RMS']
              },
              component: () => import("@/components/RoomSale/Dynamic/Overview.vue")
            },
          ]
        },

        // Phong trong mobile
        {
          path: "mobile",
          name: "mobile",
          redirect: "/mobile/inventory",
          meta: {
            roles: [Role.MANAGE, Role.ROOM_SALE]
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "inventory",
              name: "inventory",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
              },
              component: () => import("@/components/mobileApp/inventory.vue"),
            },
            {
              path: "mRate",
              name: "mRate",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
              },
              component: () => import("@/components/mobileApp/rate.vue"),
            },
            {
              path: "stopSell",
              name: "stopSell",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
              },
              component: () => import("@/components/mobileApp/stopSell.vue"),
            },
            {
              path: "bookingDetail/:code",
              name: "bookingDetailMobile",
              meta: {
                roles: [Role.MANAGE, Role.ROOM_SALE, Role.ROOM_SALE_MANAGEMENT]
              },
              component: () => import("@/components/mobileApp/bookingDetail.vue"),
            },
            {
              path: "app",
              name: "app",
              meta: {
                roles: []
              },
              component: () => import("@/components/mobileApp/app.vue"),
            },
          ]
        },

        // QUẢN LÝ ĐỒNG BỘ
        {
          path: "sync-manage",
          redirect: "/sync-manage/ezCmsVela",
          name: "aliasOTAS",
          meta: {
            roles: [Role.MANAGE]
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "ezPriceLabs",
              name: "ezPriceLabs",
              meta: {
                roles: ['RPD']
              },
              component: () => import("@/components/SyncOTA/ezCmsPriceLabs.vue")
            },
            {
              path: "ezCmsVelaPlus",
              name: "ezCmsVelaPlus",
              meta: {
                roles: [Role.OTA_MANAGEMENT]
              },
              component: () => import("@/components/SyncOTA/ezCmsVelaPlus.vue")
            },
            // Quản lý ánh xạ OTA
            {
              path: "ezCmsVela",
              name: "ezCmsVela",
              meta: {
                roles: [Role.OTA_MANAGEMENT]
              },
              component: () => import("@/components/SyncOTA/ezCmsVela.vue")
            },
            {
              path: "ezCms1H",
              name: "ezCms1H",
              meta: {
                roles: [Role.OTA_MANAGEMENT]
              },
              component: () => import("@/components/SyncOTA/ezCms1H.vue")
            },
            {
              path: "ezCmsLeo",
              name: "ezCmsLeo",
              meta: {
                roles: ['SU_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezCmsLeo.vue")
            },
            {
              path: "ezCms1i",
              name: "ezCms1i",
              meta: {
                roles: ['GDS_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezCms1i.vue")
            },
            {
              path: "ezCms1T",
              name: "ezCms1T",
              meta: {
                roles: ['GDS_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezCms1T.vue")
            },
            {
              path: "ezCms1S",
              name: "ezCms1S",
              meta: {
                roles: ['GDS_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezCms1S.vue")
            },
            {
              path: "ezCms1X",
              name: "ezCms1X",
              meta: {
                roles: ['GDS_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezCms1X.vue")
            },
            {
              path: "ezCmsSiteminder",
              name: "ezCmsSiteminder",
              meta: {
                roles: ['SITEMINDER_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezCmsSiteminder.vue")
            },
            {
              path: "ezbe-ota",
              name: "ezbe",
              meta: {
                roles: ['BE_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezBe.vue")
            },
            {
              path: "ezApiPms",
              name: "ezApiPms",
              meta: {
                roles: ['BE_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezApiPms.vue")
            },
            {
              path: "ezApiKiosk",
              name: "ezApiKiosk",
              meta: {
                roles: ['BE_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezApiKiosk.vue")
            },
            {
              path: "ezApiApp",
              name: "ezApiApp",
              meta: {
                roles: ['BE_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezApiApp.vue")
            },
            {
              path: "ezCmsTraveloka",
              name: "ezCmsTraveloka",
              meta: {
                roles: ['TRAVELOKA_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezCmsTraveloka.vue")
            },
            {
              path: "ezCmsStaahMax",
              name: "ezCmsStaahMax",
              meta: {
                roles: ['STAAH_MANAGEMENT']
              },
              component: () => import("@/components/SyncOTA/ezCmsStaahMax.vue")
            },
          ]
        },

        // GIAO DỊCH THU CHI
        {
          path: "transaction",
          redirect: "/transaction/list",
          name: "transaction",
          meta: {
            roles: [Role.MANAGE]
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "list",
              name: "transactionList",
              meta: {
                roles: [Role.MANAGE]
              },
              component: () => import("@/components/RoomSale/Transaction/ListOfTransaction.vue")
            },
            {
              path: "detail/",
              name: "transactionDetail",
              meta: {
                roles: [Role.MANAGE]
              },
              component: () => import("@/components/RoomSale/Transaction/TransactionDetail.vue")
            }
          ]
        },

        // dịch vụ
        {
          path: "service",
          redirect: "/service/list",
          name: "service",
          meta: {
            roles: [Role.MANAGE]
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "list",
              name: "serviceList",
              meta: {
                roles: [Role.MANAGE]
              },
              component: () => import("@/components/RoomSale/Service/ListOfService.vue")
            },
            {
              path: "detail/:id",
              name: "serviceDetail",
              meta: {
                roles: [Role.MANAGE]
              },
              component: () => import("@/components/RoomSale/Service/ServiceDetail.vue")
            }
          ]
        },

        // QUẢN LÝ KHUYẾN MẠI
        {
          path: "promotion",
          redirect: "/promotion/list",
          name: "promotion",
          meta: {
            roles: [Role.MANAGE]
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "list",
              name: "promotionList",
              meta: {
                roles: [Role.MANAGE]
              },
              component: () => import("@/components/RoomSale/Promotion/ListOfPromotions.vue")
            },
            {
              path: "detail/:id",
              name: "promotionDetail",
              meta: {
                roles: [Role.MANAGE]
              },
              component: () => import("@/components/RoomSale/Promotion/PromotionPackageDetail.vue")
            }
          ]
        },
        // Master rate
        {
          path: "master-rate",
          redirect: "/master-rate/overview",
          name: "master-rate",
          meta: {
            roles: []
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "overview",
              name: "master-rate-overview",
              meta: {
                roles: []
              },
              component: () => import("@/components/MasterRate/Overview.vue")
            },
            {
              path: "calculate",
              name: "calculate",
              meta: {
                roles: []
              },
              component: () => import("@/components/MasterRate/Calculate.vue")
            },
            {
              path: "calculateByDate",
              name: "calculateByDate",
              meta: {
                roles: []
              },
              component: () => import("@/components/MasterRate/CalculateByDate.vue")
            }
          ]
        },

        // THÔNG TIN TÀI KHOẢN
        {
          path: "account",
          name: "accountSetting",
          redirect: "/account/my-account",
          meta: {
            roles: [Role.SETTING, Role.ACCOUNT_INFOMATION, Role.PERSONAL_ACCOUNT]
          },
          component: () => import("@/views/About.vue"),
          children: [
            // Tài khoản cá nhân
            {
              path: "my-account",
              name: "accountSetting",
              meta: {
                roles: [
                  Role.SETTING,
                  Role.ACCOUNT_INFOMATION,
                  Role.PERSONAL_ACCOUNT
                ]
              },
              component: () =>
                import("@/components/Account/Setting/AccountSetting.vue")
            }
          ]
        },

        // THÔNG TIN KHÁCH SẠN
        {
          path: "hotel-setting",
          name: "roomInfos",
          redirect: "cancellation/list-of-cancellation",
          meta: {
            roles: [Role.SETTING, Role.HOTEL_INFORMATION]
          },
          component: () => import("@/views/About.vue"),
          children: [
            // Thông tin chung
            {
              path: "info",
              redirect: "register",
              name: "generalInfo",
              meta: {
                roles: [Role.SETTING, Role.GENERAL_INFORMATION]
              },
              component: () => import("../components/HotelSetting/Info/Info.vue"),
              children: [
                {
                  path: "register",
                  name: "registerInfomation",
                  meta: {
                    roles: [Role.SETTING, Role.GENERAL_INFORMATION]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Info/RegisterInfomation.vue")
                },
                {
                  path: "amenities",
                  name: "hotelAmenities",
                  meta: {
                    roles: [
                      Role.SETTING,
                      Role.GENERAL_INFORMATION,
                      Role.HOTEL_AMENITY
                    ]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Info/Extension.vue")
                },
                {
                  path: "images",
                  name: "hotelImages",
                  meta: {
                    roles: [
                      Role.SETTING,
                      Role.GENERAL_INFORMATION,
                      Role.HOTEL_IMAGE
                    ]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Info/Image.vue")
                },
                {
                  path: "nearby",
                  name: "nearby",
                  meta: {
                    roles: [
                      Role.SETTING,
                      Role.GENERAL_INFORMATION,
                      Role.NEARBY_PLACE
                    ]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Info/NearbyPlace.vue")
                }
              ]
            },
            // Cấu hình khách sạn
            {
              path: "config",
              redirect: "config/general",
              name: "hotelSettingConfig",
              meta: {
                roles: [Role.SETTING, Role.HOTEL_CONFIGURATION]
              },
              component: () =>
                import("../components/HotelSetting/Config/Config.vue"),
              children: [
                {
                  path: "general",
                  name: "generalSetting",
                  meta: {
                    roles: [
                      Role.SETTING,
                      Role.HOTEL_CONFIGURATION,
                      Role.GENERAL_CONFIGURATION
                    ]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Config/GeneralSetting.vue")
                },
                {
                  path: "payment",
                  redirect: "payment/list-of-payment",
                  name: "paymentPolicy",
                  meta: {
                    roles: [
                      Role.SETTING,
                      Role.HOTEL_CONFIGURATION,
                      Role.PAYMENT_POLICY
                    ]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Config/PaymentPolicy/PaymentPolicy.vue"),
                  children: [
                    {
                      path: "list-of-payment",
                      name: "listOfPayments",
                      meta: {
                        roles: [
                          Role.SETTING,
                          Role.HOTEL_CONFIGURATION,
                          Role.PAYMENT_POLICY
                        ]
                      },
                      component: () =>
                        import("@/components/HotelSetting/Config/PaymentPolicy/ListOfPayments.vue")
                    },
                    {
                      path: "edit/:id",
                      name: "editPaymentPolicy",
                      meta: {
                        roles: [
                          Role.SETTING,
                          Role.HOTEL_CONFIGURATION,
                          Role.PAYMENT_POLICY
                        ]
                      },
                      component: () =>
                        import("@/components/HotelSetting/Config/PaymentPolicy/AddPolicy.vue")
                    }
                  ]
                },
                {
                  path: "cancellation",
                  redirect: "cancellation/list-of-cancellation",
                  name: "cancellationPolicy",
                  meta: {
                    roles: [
                      Role.SETTING,
                      Role.HOTEL_CONFIGURATION,
                      Role.CANCELLATION_POLICY
                    ]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Config/Cancellation/CancellationPolicy.vue"),
                  children: [
                    {
                      path: "list-of-cancellation",
                      name: "listOfCancellations",
                      meta: {
                        roles: [
                          Role.SETTING,
                          Role.HOTEL_CONFIGURATION,
                          Role.CANCELLATION_POLICY
                        ]
                      },
                      component: () =>
                        import("@/components/HotelSetting/Config/Cancellation/ListOfCancellations.vue")
                    },
                    {
                      path: "edit/:id",
                      name: "editCancellationPolicy",
                      meta: {
                        roles: [
                          Role.SETTING,
                          Role.HOTEL_CONFIGURATION,
                          Role.CANCELLATION_POLICY
                        ]
                      },
                      component: () =>
                        import("@/components/HotelSetting/Config/Cancellation/AddCancellation.vue")
                    }
                  ]
                },
                {
                  path: "paymentMethod",
                  name: "paymentMethod",
                  meta: {
                    roles: [
                      Role.SETTING,
                      Role.HOTEL_CONFIGURATION,
                      'PAYMENT_METHOD'
                    ]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Config/PaymentMethod/PayGate.vue")
                },
                {
                  path: "warningMethod",
                  name: "warningMethod",
                  meta: {
                    roles: [
                      Role.SETTING,
                      Role.HOTEL_CONFIGURATION,
                      Role.WARNING_METHOD
                    ]
                  },
                  component: () =>
                    import("@/components/HotelSetting/Config/WarningMethod.vue")
                },
              ]
            },
            // Quản lý thư viện ảnh
            {
              path: "gallery",
              name: "hotelSettingGallery",
              meta: {
                roles: [Role.SETTING, Role.IMAGE_LIBRARY]
              },
              component: () =>
                import("@/components/HotelSetting/GalleryManager/GalleryManager.vue")
            },
            // Thông tin loại phòng
            {
              path: "room",
              name: "roomGroup",
              redirect: "room/room-type",
              meta: {
                roles: [Role.SETTING, Role.ROOM_TYPE]
              },
              component: () =>
                import("@/components/HotelSetting/RoomComponent.vue"),
              children: [
                {
                  path: "room-type",
                  name: "roomInfo",
                  meta: {
                    roles: [Role.SETTING, Role.ROOM_TYPE]
                  },
                  component: () =>
                    import("@/components/HotelSetting/RoomType/ListRoom.vue")
                },
                {
                  path: "room-category",
                  name: "roomCategorys",
                  meta: {
                    roles: [Role.SETTING, Role.ROOM_TYPE]
                  },
                  component: () =>
                    import("@/components/HotelSetting/RoomCategory/ListRoomCategory.vue")
                },
              ]
            },
            {
              path: "room-type/room-detail/:id",
              redirect: "room-type/room-detail/:id/infor",
              name: "roomDetail",
              meta: {
                roles: [Role.SETTING, Role.ROOM_TYPE]
              },
              component: () =>
                import("@/components/HotelSetting/RoomType/RoomDetail.vue"),
              children: [
                {
                  path: "infor",
                  name: "roomInformation",
                  meta: {
                    roles: [Role.SETTING, Role.ROOM_TYPE]
                  },
                  component: () =>
                    import("@/components/HotelSetting/RoomType/RoomInfomation.vue")
                },
                {
                  path: "amenities",
                  name: "roomAmenities",
                  meta: {
                    roles: [Role.SETTING, Role.ROOM_TYPE]
                  },
                  component: () =>
                    import("@/components/HotelSetting/RoomType/RoomExtension.vue")
                },
                {
                  path: "images",
                  name: "roomImages",
                  meta: {
                    roles: [Role.SETTING, Role.ROOM_TYPE]
                  },
                  component: () =>
                    import("@/components/HotelSetting/RoomType/RoomImage.vue")
                }
              ]
            },
            {
              path: "agent",
              name: "agent-hotel",
              meta: {
                roles: ['HOTEL_TRAVEL_AGENT']
              },
              component: () =>
                import("@/components/HotelSetting/AgentList.vue")
            },
            {
              path: "agent/agentInfomation/:id",
              name: "agent-infomation",
              component: () => import("@/components/HotelSetting/AgentInfomation.vue"),
              meta: {
                roles: ['HOTEL_TRAVEL_AGENT']
              }
            },

            {
              path: "room-category/detail/:id",
              name: "roomCategoryDetail",
              meta: {
                roles: [Role.SETTING, Role.ROOM_TYPE]
              },
              component: () =>
                import("@/components/HotelSetting/RoomCategory/DetailRoomCategory.vue")
            },
          ]
        },

        // LOG
        {
          path: "hotel-log",
          name: "hotelLog",
          redirect: "/hotel-log/log",
          meta: {
            roles: [Role.HISTORY_LOG]
          },
          component: () => import("@/views/About.vue"),
          children: [
            // GET LOG
            {
              path: "log",
              name: "hotelLogList",
              meta: {
                roles: [Role.HISTORY_LOG]
              },
              component: () => import("@/components/Log/Log.vue")
            },
            {
              path: "logOta",
              name: "OTALog",
              meta: {
                roles: [Role.HISTORY_LOG]
              },
              component: () => import("@/components/Log/OTALog.vue")
            },
            {
              path: "logInventory",
              name: "inventoryLog",
              meta: {
                roles: [Role.HISTORY_LOG]
              },
              component: () => import("@/components/Log/InventoryLog.vue")
            },
            {
              path: "logError",
              name: "errorLog",
              meta: {
                roles: [Role.HISTORY_LOG]
              },
              component: () => import("@/components/Log/ErrorLog.vue")
            }
          ]
        },
        {
          path: "hotel-be",
          name: "BeConfig",
          redirect: "/hotel-be/email",
          meta: {
            roles: ['BOOKING_ENGINE_CONFIG']
          },
          component: () => import("@/views/About.vue"),
          children: [
            // GET LOG
            {
              path: "email",
              name: "email",
              meta: {
                roles: ['HOTEL_EMAIL']
              },
              component: () => import("@/components/BeConfig/Email.vue")
            },
            {
              path: "theme",
              name: "theme",
              meta: {
                roles: ['HEADER_FOOTER']
              },
              component: () => import("@/components/BeConfig/Theme.vue")
            },
            {
              path: "support",
              name: "support",
              meta: {
                roles: []
              },
              component: () =>
                import("@/components/BeConfig/ConnectBE.vue")
            },
          ]
        },
        // Combo
        {
          path: "combo",
          name: "combo",
          redirect: "/combo/services",
          meta: {
            roles: ['PACKAGE_MANAGEMENT']
          },
          component: () => import("@/views/About.vue"),
          children: [
            {
              path: "services",
              name: "service-combo",
              meta: {
                roles: ['PACKAGE_ITEM']
              },
              component: () =>
                import("@/components/Combo/Service/Services.vue")
            },
            {
              path: "services/detail/:id",
              name: "service-combo-detail",
              meta: {
                roles: ['PACKAGE_ITEM']
              },
              component: () =>
                import("@/components/Combo/Service/ServiceDetail.vue")
            },
            {
              path: "package",
              name: "package",
              meta: {
                roles: ['PACKAGE_DEAL']
              },
              component: () =>
                import("@/components/Combo/Package/Packages.vue")
            },
            {
              path: "package/detail/:id",
              name: "detail-room-rate-package",
              meta: {
                roles: ['PACKAGE_DEAL']
              },
              component: () =>
                import("@/components/Combo/Package/PackageDetail.vue")
            },
          ]
        },
      ]
    },


    // CHAIN
    {
      path: "/chain-dashboard",
      name: "chain-dashboard",
      redirect: "/chain-dashboard/chain-list",
      meta: {
        roles: [
          // Role.CHAIN
        ]
      },
      component: () => import("@/views/Main-Chain.vue"),
      children: [
        {
          path: "chain-list",
          name: "chain-list",
          component: () => import("@/components/Chain/ListChain.vue"),
          meta: {
            roles: [
              // Role.CHAIN,
              // Role.CHAIN_LIST
            ]
          }
        },
        {
          path: "booking-list",
          name: "booking-list",
          component: () => import("@/components/Chain/ListBookingChain.vue"),
          meta: {
            roles: [Role.CHAIN, Role.BOOKING_CHAIN]
          }
        },
        {
          path: "detail/:code",
          name: "chainBookingDetail",
          component: () => import("@/components/Chain/BookingDetail.vue"),
          meta: {
            roles: [Role.CHAIN, Role.BOOKING_CHAIN]
          }
        },
        // Danh sách user
        {
          path: "user",
          name: "listUser",
          meta: {
            roles: [Role.CHAIN, Role.USER_MANAGEMENT]
          },
          component: () =>
            import("../components/Account/ManageUser/ListUser.vue")
        },
        // Danh sách nhóm
        {
          path: "group",
          name: "listGroup",
          meta: {
            roles: [
              Role.CHAIN, Role.USER_MANAGEMENT
            ]
          },
          component: () =>
            import("../components/Account/ManageUser/ListGroup.vue")
        },

        // Thêm mới thành viên
        {
          path: "user/add",
          name: "addUser",
          meta: {
            roles: [Role.CHAIN, Role.USER_MANAGEMENT]
          },
          component: () =>
            import("@/components/Account/ManageUser/EditUser.vue")
        },
        // Sửa thành viên
        {
          path: "user/:id",
          name: "editUser",
          meta: {
            roles: [Role.CHAIN, Role.USER_MANAGEMENT]
          },
          component: () =>
            import("@/components/Account/ManageUser/EditUser.vue")
        },
        // Thêm mới nhóm
        {
          path: "group/add",
          name: "addGroup",
          meta: {
            roles: [
              Role.CHAIN, Role.USER_MANAGEMENT
            ]
          },
          component: () =>
            import("../components/Account/ManageUser/EditGroup.vue")
        },
        // Sửa nhóm
        {
          path: "group/:id",
          name: "editGroup",
          meta: {
            roles: [
              Role.CHAIN, Role.USER_MANAGEMENT
            ]
          },
          component: () =>
            import("../components/Account/ManageUser/EditGroup.vue")
        }
      ]
    },


    // #endregion
    { path: "*", redirect: "/chain-dashboard" }
  ]
});

router.beforeEach((to, from, next) => {
  document.title = i18n.t('IS_REDIRECTING') + '...';
  const publicPages = ["/login", "/change-pass", "/register", "/admin/login"];
  const authRequired = !publicPages.includes(to.path);
  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const hostname = window.location.hostname;
  if (authRequired && (!currentUser || !currentUser.user)) {
    if (hostname.includes('ezcrs') || hostname.includes('ezcms') || (jsonData[hostname] && jsonData[hostname].isLoginAdmin === false)) {
      next({ name: "login" });
    } else {
      next({ name: "login-admin" });
    }
  } else {
    const screenRoles = to.meta.roles;
    if (screenRoles && screenRoles.length > 0) {
      // Screen has roles, check is Authorized
      let isAuthorized = true;
      const userRole = currentUser.user.roles
        ? currentUser.user.roles.map(role => role.fnCode)
        : undefined;
      if (!userRole || !userRole.length) {
        // Redirect to dashboard
        authenticationService.logout(false);
        if (hostname.includes('ezcrs') || hostname.includes('ezcms') || (jsonData[hostname] && jsonData[hostname].isLoginAdmin === false)) {
          return next({ name: "login" });
        } else {
         return next({ name: "login-admin" });
        }
      }

      // Nếu không được phân quyền menu nào thì ẩn menu đó
      // if ( to.fullPath.includes("chain-list") ) {
      //     if (userRole.indexOf("CHAIN_LIST") < 0) {
      //         if (userRole.indexOf("BOOKING_CHAIN") >= 0) {
      //             next({ name: "booking-list" });
      //         } else {
      //             if (userRole.indexOf("USER_MANAGEMENT") >= 0) {
      //                 next({ name: "listUser" });
      //             }
      //         }
      //     }
      // }

      // chain-dashboard if no hotel selected
      if (!currentUser.hotel && !to.fullPath.includes("chain-dashboard")) {
        next({ name: "chain-dashboard" });
      }

      // for (const role of screenRoles) {
      //   if (userRole.indexOf(role) < 0) {
      //     isAuthorized = false;
      //     break;
      //   }
      // }
      isAuthorized = screenRoles.every(element => userRole.includes(element));
      if (isAuthorized) {
        // Go to next page
        document.documentElement.scrollTop = 0;
        if (to.matched.find(e => e.name === 'chain')) {
          const queryString = window.location.href;
          const ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
          if (ob.hotel.chainId) {
            next();
          } else {
            next({ name: "widgets", params: to.params });
          }
        } else {
          next();
        }
      } else {
        // Redirect to dashboard
        return next({ name: "widgets", params: to.params });
      }
    } else {
      // Screen does not have role, go to next page
      document.documentElement.scrollTop = 0;
      next();
    }
  }
  document.documentElement.scrollTop = 0;
  next();
});
router.afterEach((to) => {
  const domain = window.location.hostname;
  setTimeout(() => {
    if (domain.includes('ezcrs') || domain.includes('ezcms') || domain == 'localhost') {
      if (i18n.locale !== "vi") {
        document.title = "ezCrs - Central Reservation System";
      } else {
        document.title = "ezCrs - Hệ thống đặt phòng tập trung";
      }
    } else {
      if (i18n.locale !== "vi") {
        document.title = "Central Reservation System";
      } else {
        document.title = "Hệ thống đặt phòng tập trung";
      }
    }
  }, 500);
});